import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Qualification Qualification_Container_Process" }
const _hoisted_2 = { class: "Qualification_Container_Process_p1" }
const _hoisted_3 = { class: "Qualification_Container_Process_icon" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "Qualification_Container_Process_p2" }, "Por favor espere mientras se recibe respuesta del proceso de habilitación", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode("Generando set de pruebas "),
      _createElementVNode("em", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: "sync",
          class: "fa-spin"
        })
      ])
    ]),
    _hoisted_4
  ]))
}